<template>
  <div class="div-table justify-content-center">
    <p class="text-right mr-2"><b>Full Name</b></p>
    <p class="ml-1">
      {{
        UserForm.postData.person.firstName +
        " " +
        UserForm.postData.person.lastName
      }}
    </p>
    <p class="text-right mr-2"><b>Email</b></p>
    <p class="ml-1">
      {{ UserForm.postData.person.email }}
    </p>
    <p class="text-right mr-2"><b>Phone</b></p>
    <p class="ml-1">
      {{ UserForm.postData.person.cellNumber }}
    </p>
  </div>
</template>
<script>
export default {
  inject: ["UserForm"],
};
</script>
<style scoped>
.div-table {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
</style>
